import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";

export const OficialVigente = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/company/oficial-vigente").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);
  if (!items) return null;
  return (
    <p className="text-sm" data-testid="oficial-vigente">
      <b>Oficial de cumplimiento vigente:</b>{" "}
      {items.length ? items.map((u) => `${u.nombre}${u.misma_persona_en_ambos_roles ? " (owner, misma persona en ambos roles)" : ""}`).join(", ")
        : <span className="text-rose-700">sin oficial designado</span>}
    </p>
  );
};

export const OwnerOficialCard = () => {
  const { me, refresh } = useAuth();
  const [m, setM] = useState("");
  const u = me.usuario;
  const toggle = useCallback(async () => {
    try {
      await api.post(`/company/users/${u.id}/tambien-oficial`, { motivo: m });
      toast.success("Registrado en la bitácora");
      setM("");
      refresh();
    } catch (e) {
      toast.error(errMsg(e));
    }
  }, [u.id, m, refresh]);
  if (u.rol !== "owner") return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 space-y-2" data-testid="owner-also-officer">
      <p className="text-sm">{u.tambien_oficial ? "Eres owner y también oficial de cumplimiento (misma persona en ambos roles). Las aprobaciones siguen siendo dos pasos separados." : "En empresas pequeñas el owner puede asumir también el rol de oficial de cumplimiento."}</p>
      <Textarea placeholder="Motivo (obligatorio, mínimo 10 caracteres)" value={m} onChange={(e) => setM(e.target.value)} data-testid="owner-also-officer-motivo" />
      <Button size="sm" variant="outline" disabled={m.trim().length < 10} onClick={toggle} data-testid="owner-also-officer-toggle">
        {u.tambien_oficial ? "Dejar el rol de oficial" : "Asumir también el rol de oficial"}</Button>
    </div>
  );
};
